__webpack_require__.p = "https://wss-live-assets.azureedge.net/assets/2025.112.1/_next/";